import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FileManagerService } from '../file-manager.service';
import { FileManagerUploadComponent } from '../file-manager-upload/file-manager-upload.component';
import { MessagingService } from '../../../services/messaging.service';
import {UiService} from '../../../services/ui.service';

@Component({
  standalone: false,
  selector: 'app-file-manager-view',
  templateUrl: './file-manager-view.component.html',
  styleUrls: ['./file-manager-view.component.css']
})
export class FileManagerViewComponent implements OnInit, OnDestroy {
  constructor(
    private fileService: FileManagerService,
    private messagingService: MessagingService,
    private dialog: MatDialog,
    public uiService: UiService
  ) { }

  /*
   * Need to take @Input variables to determine what images to show
   * This includes tags - such as the profile picture/default for patient
   * add a context menu. When you right click this image OR placeholder (if no image) you open the file manager upload view
   * Allow for attributes like 'single' to show a single image
   * 'multiple' to show an array of images - vertical or horizontal to show orientation - width - height etc
   *
   */

  @Input() roundImage: boolean = false;
  @Input() roundCorners: boolean = false;

  @Input() width: number = 200;
  @Input() height: number = 300;
  @Input() orientation: string = 'horizontal';
  @Input() viewType: string = 'multi';
  @Input() previewType: string;

  // @Input() PatientId: string = null;
  @Input() PatientId: string;
  @Input() PatientCaseId: string = null;
  @Input() CaseWorkItemId: string = null;
  @Input() LOCID: number = null;
  @Input() WorkItemEventId: string = null;
  @Input() Description: string = null;
  @Input() DocumentFileName: string = null;
  @Input() enumDocumentFileTypeID: string = null;
  @Input() enumDocumentTypeID: string = null;
  @Input() DocumentOrder: number = null;
  @Input() ParentDocumentID: string = null;
  @Input() ImageSpreadPKID: number = null;
  @Input() enumDocumentTags: string[] = [];
  @Input() DocumentGroupId: string;
  @Input() ignoreUpdate: boolean = false;

  @Input() DocumentFolderParentId: string = null;
  @Input() FolderName: string = null;
  @Input() FolderOrder = null;
  //@Input() enumDocumnetFolderTypeID: string = null;

  @Input() previewTitle: string;

  isLoading: boolean = false;
  dataDocumentFolder: any;
  dataDocuments: any[] = [];
  contextPositionX = 0;
  contextPositionY = 0;
  showContext: boolean = false;
  messageSubscription: any;
  documentGroup: any;

  imageExtList: string[] = [
    'apng',
    'bmp',
    'gif',
    'gif',
    'ico',
    'cur',
    'jpg',
    'jpeg',
    'jfif',
    'pjpeg',
    'pjp',
    'png',
    'svg',
    'tif',
    'tiff',
    'webp'
  ];



  loadSubscription: any;

  ngOnDestroy() {

    if (this.loadSubscription) {
      this.loadSubscription.unsubscribe();
      this.loadSubscription = false;
    }

    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
      this.messageSubscription = false;
    }

  }

  ngOnInit() {

    //console.log("FileManagerViewComponent ngOnInit");

    this.messageSubscription = this.messagingService.componentMessageCall.subscribe(response => {

      if (response.event == 'Document-Manager-Refresh' && !this.ignoreUpdate) {

        if (response.data.excludeTags) {

          let flag = false;
          response.data.excludeTags.forEach(tag => {

            const foundTag = this.enumDocumentTags.find(enumTag => {
              return tag === enumTag;
            });

            if (foundTag) {
              flag = true;
            }
          });

          if (!flag) {
            this.init();
          }

        } else {
          this.init();
        }

        this.init();
      }

      if (response.event == 'Document-Manager-Document-Removed' && !this.ignoreUpdate) {

        const countBefore = this.dataDocuments.length;
        this.dataDocuments = this.dataDocuments.filter(document => {
          return document.DocumentID != response.data.DocumentID;
        });
        if (this.dataDocuments.length != countBefore && this.viewType === 'single') {
          this.init();
        }

      }

    });
    this.enumDocumentTags = this.enumDocumentTags.map(tag => {
      return tag.toLowerCase();
    });

    this.init();
  }

  sortDataDocuments() {
    if (this.dataDocuments.length == 0) {
      return;
    }

    this.dataDocuments = this.dataDocuments.sort((a, b) => {
      var d1 = new Date(a.DocumentModifiedDate);
      var d2 = new Date(b.DocumentModifiedDate);
      return d2.getTime() - d1.getTime();
    });
  }

  initWithGroup() {
     console.log("FileManagerViewComponent initWithGroup");
    this.isLoading = true;
    this.getDocumentGroup()
      .then((documentGroup: any) => {
        console.log("FileManagerViewComponent getDocumentGroup", documentGroup);

        this.documentGroup = documentGroup;
        this.dataDocuments = [];
        this.documentGroup.dataDocumentGroupDocuments.forEach((groupDocument: any) => {
          this.dataDocuments.push(groupDocument.dataDocument);
        });

        this.dataDocuments = this.dataDocuments.filter(document => {
          return document.xauditDeleted === false;
        });

        this.dataDocuments = this.dataDocuments.filter(document => {
          const currentFileExtension = document.DocumentFileName.split('.').pop();
          if (this.imageExtList.indexOf(currentFileExtension.toLowerCase()) > -1) {
            return true;
          } else {
            return false;
          }
        });

        this.sortDataDocuments();
        this.filterDocumentsByTag();
        this.isLoading = false;

      }, err => {
        this.isLoading = false;
      });
  }

  init() {
     //console.log("FileManagerViewComponent init");
     //console.log("FileManagerViewComponent previewtype", this.previewType);
     //console.log("FileManagerViewComponent DocumentGroupId", this.DocumentGroupId);

    if (this.DocumentGroupId) {
      this.initWithGroup();
    } else if (this.PatientId) {
      this.isLoading = true;
      this.getPatientFolder(this.PatientId)
        .then((result: any[]) => {
          // console.log("FileManagerViewComponent getPatientFolder", result);
          if (result && result.length) {
            this.dataDocuments = [];

            result.forEach(folder => {
              folder.dataDocumentInFolders.forEach(dif => {
                this.dataDocuments = this.dataDocuments.concat(dif.dataDocument);
              });
            });
          }
          // console.log("FileManagerViewComponent dataDocuments", JSON.parse(JSON.stringify(this.dataDocuments)));
         // this.dataDocuments = this.dataDocuments.filter(document => {
        //  return document.xauditDeleted === false;
          //});
          // console.log("FileManagerViewComponent dataDocuments filtered deleted", JSON.parse(JSON.stringify(this.dataDocuments)));
          this.dataDocuments = this.dataDocuments.filter(document => {
            const currentFileExtension = document.DocumentFileName.split('.').pop();
            if (this.imageExtList.indexOf(currentFileExtension.toLowerCase()) > -1) {
              return true;
            } else {
              return false;
            }
          });
          //console.log("FileManagerViewComponent dataDocuments filtered extension", JSON.parse(JSON.stringify(this.dataDocuments)));

          this.filterDocumentByCase();
          //console.log("FileManagerViewComponent dataDocuments filtered by case", JSON.parse(JSON.stringify(this.dataDocuments)));
          this.sortDataDocuments();
          //console.log("FileManagerViewComponent dataDocuments sorted", JSON.parse(JSON.stringify(this.dataDocuments)));

          this.filterDocumentsByTag();
          //console.log("FileManagerViewComponent dataDocuments filtered by tag", JSON.parse(JSON.stringify(this.dataDocuments)));
          this.isLoading = false;
        }, err => {
          this.isLoading = false;
        });
    }
  }

  getDocumentGroup() {
    const promise = new Promise((resolve, reject) => {
      this.fileService.getDocumentGroup(this.DocumentGroupId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  filterDocumentByCase() {
    // console.log("FileManagerViewComponent filterDocumentByCase");

    if (!this.CaseWorkItemId) {
      return;
    }

    this.dataDocuments = this.dataDocuments.filter((document: any) => {
      return document.CaseWorkItemId === this.CaseWorkItemId;
    });
    // console.log("FileManagerViewComponent filterDocumentByCase filtered", JSON.parse(JSON.stringify(this.dataDocuments)));

  }

  filterDocumentsByTag() {
    if (!this.enumDocumentTags.length) {
      if (this.viewType === 'single' && this.dataDocuments.length > 1) {
        this.dataDocuments = this.dataDocuments.splice(0, 1);
      }
      return;
    }
     //console.log("FileManagerViewComponent filterDocumentByTag", JSON.parse(JSON.stringify(this.dataDocuments)));

    this.dataDocuments = this.dataDocuments.filter((document: any) => {
      let documentTags = document.dataDocumentTags.map((documentTag: any) => {
        return documentTag.enumDocumentTagID;
      });

      documentTags = documentTags.filter((documentTag: any) => {
        return this.enumDocumentTags.indexOf(documentTag.toLowerCase()) > -1;
      });

      return documentTags.length;
    });
     //console.log("FileManagerViewComponent filterDocumentByTag filtered", JSON.parse(JSON.stringify(this.dataDocuments)));

    if (this.viewType === 'single' && this.dataDocuments.length > 1) {
      this.dataDocuments = this.dataDocuments.splice(0, 1);
    }
  }

  getPatientFolder(patientId: string) {
    const promise = new Promise((resolve, reject) => {
      if (this.loadSubscription) {
        this.loadSubscription.unsubscribe();
        this.loadSubscription = false;
      }

      this.fileService.getPatientFolderPromise(patientId)
        .then((response) => {
          this.loadSubscription = false;
          resolve(response);
        }, err => {
          this.loadSubscription = false;
          reject(err);
        });

    });
    return promise;
  }

  findDocument(documentId: string) {
    const promise = new Promise((resolve, reject) => {
      this.fileService.getDocument(documentId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  public handleUploadClicked() {

    const tmp: any = {
      PatientId: this.PatientId,
      PatientCaseId: this.PatientCaseId,
      CaseWorkItemId: this.CaseWorkItemId,
      LOCID: this.LOCID,
      WorkItemEventId: this.WorkItemEventId,
      Description: this.Description,
      DocumentFileName: this.DocumentFileName,
      enumDocumentFileTypeID: this.enumDocumentFileTypeID,
      enumDocumentTypeID: this.enumDocumentTypeID,
      DocumentOrder: this.DocumentOrder,
      ParentDocumentID: this.ParentDocumentID,
      ImageSpreadPKID: this.ImageSpreadPKID,
      enumDocumentTags: this.enumDocumentTags.join('|'),
      DocumentGroupId: this.DocumentGroupId,
    };

    const data = {};

    for (const i in tmp) {
      if (tmp[i]) {
        data[i] = tmp[i];
      }
    }

    const dialogRef = this.dialog.open(FileManagerUploadComponent, {
      width: '800px',
      height: '800px',      
      data
    });
    dialogRef.afterClosed().subscribe(result => {
      this.showContext = false;
      if (result) {
        this.messagingService.recursiveBroadCastMessage('Document-Manager-Refresh', {});
      }
    }, err => {
      this.showContext = false;
    });

  }

  onRightClickScheduleEvent(event, schedule) {

    this.handleUploadClicked();

    // console.log('CONTEXT');

    // this.contextPositionX = event.clientX;
    // this.contextPositionY = event.clientY;
    // this.showContext = true;
  }

  hideContextMenu() {
    this.showContext = false;
  }

}
